module.exports = __webpack_public_path__ + "img/seminarscoreimportoutput.4ae3410d.jpeg";